module.exports = "<app-sidemenu></app-sidemenu>\n<br>\n<section class=\"contenido\">\n  <router-otlet></router-otlet>\n</section>\n\n"